import script from "./BaseTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTooltip.vue?vue&type=style&index=0&id=7cef5cfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cef5cfa"]])

export default __exports__